import {styled} from "@mui/material";
import {Typography} from "@mui/material";
import {Box} from "@mui/system";
import React from "react";

const SubTitleContainer = styled(Box)(
  ({theme}) => `
  position:relative;
  z-index: 100;
  display: flex;
  align-items: center;
  padding: 16px 12px;
  background-color:${theme.palette.background.default} ;
  background-clip: border-box;
  border: 0px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.75rem;
  box-shadow: rgb(0 0 0 / 10%) 0rem 0.25rem 0.375rem -0.0625rem, rgb(0 0 0 / 6%) 0rem 0.125rem 0.25rem -0.0625rem;
`
);

const SubTitleMark = styled(Box)(
  ({theme}) => `
  width: 24px;
  height: 24px;
  margin-right: 12px;
  background: linear-gradient(195deg, ${theme.palette.secondary.light}, ${theme.palette.secondary.main});
  border-radius: 50%;
  box-shadow: rgb(0 0 0 / 24%) 0rem 0.25rem 1.25rem 0rem, rgb(0 187 212 / 60%) 0rem 0.4375rem 0.625rem -0.3125rem;
`
);

interface SubTitleType {
  subTitle: string;
  children?: React.ReactNode;
}

const SubTitle = ({subTitle, children}: SubTitleType) => {
  return (
    <>
      <SubTitleContainer>
        <SubTitleMark />
        <Typography variant="h6" fontWeight={700}>
          {subTitle}
        </Typography>
        {children}
      </SubTitleContainer>
    </>
  );
};

export default SubTitle;
